<div class="d-flex h-100" *ngIf="!readonly">
  <tabset class="w-100 d-flex flex-column">
    <tab [customClass]="'tab'" heading="{{ 'common:components.markdown.markdown' | i18n }}">
      <textarea
        class="h-100 w-100 border"
        [ngModel]="value"
        (ngModelChange)="onMarkdownContentChange($event)"
      ></textarea>
    </tab>
    <tab [customClass]="'tab'" heading="{{ 'common:components.markdown.preview' | i18n }}">
      <div class="overflow-auto h-100 border p-2" #markdown></div>
    </tab>
  </tabset>
</div>
<ng-container *ngIf="!readonly">
  <input type="file" id="file-import" (change)="importCustomers($event)" />
  <label for="file-import" class="mb-0 btn btn-link file-import-label">
    {{ 'common:components.markdown.upload' | i18n }}
  </label>
</ng-container>

<div *ngIf="readonly" class="overflow-auto h-100 border p-2" #markdown></div>
